import { render, staticRenderFns } from "./kurcomp.vue?vue&type=template&id=28fe872e&"
import script from "./kurcomp.vue?vue&type=script&lang=js&"
export * from "./kurcomp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports